import { HStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

import { TableContent } from '../../../../../../components/TableContent';

export const WithdrawalLoadingMobile: React.FC = () => {
  return (
    <TableContent
      direction="column"
      space={Spacing['stack.xxxs']}
      py={Spacing['stack.xxs']}
      px={Spacing['inline.xxxs']}
      spaceX={Spacing['inline.xxxs']}>
      <HStack
        alignItems="center"
        space={Spacing['stack.nano']}
        justifyContent="space-between"
        width="100%">
        <Skeleton height={Spacing['inset.xs']} flex={1} borderRadius={BoxRadius.sm} />
        <Skeleton height={Spacing['inset.xs']} flex={1} borderRadius={BoxRadius.sm} />
      </HStack>
      <HStack
        alignItems="center"
        space={Spacing['stack.nano']}
        justifyContent="space-between"
        width="100%">
        <Skeleton height={Spacing['inset.xs']} flex={1} borderRadius={BoxRadius.sm} />
        <Skeleton height={Spacing['inset.xs']} flex={1} borderRadius={BoxRadius.sm} />
      </HStack>
      <HStack
        alignItems="center"
        space={Spacing['stack.nano']}
        justifyContent="space-between"
        width="100%">
        <Skeleton height={Spacing['inset.xs']} flex={1} borderRadius={BoxRadius.sm} />
        <Skeleton height={Spacing['inset.xs']} flex={1} borderRadius={BoxRadius.sm} />
      </HStack>
      <HStack
        alignItems="center"
        space={Spacing['stack.nano']}
        justifyContent="space-between"
        width="100%">
        <Skeleton height={Spacing['inset.xs']} flex={1} borderRadius={BoxRadius.sm} />
        <Skeleton height={Spacing['inset.xs']} flex={1} borderRadius={BoxRadius.sm} />
      </HStack>
      <HStack
        alignItems="center"
        space={Spacing['stack.nano']}
        justifyContent="space-between"
        width="100%">
        <Skeleton
          height={Spacing['inset.md']}
          width={Spacing['inset.md']}
          borderRadius={BoxRadius.sm}
        />
        <Skeleton height={Spacing['inset.md']} width="100px" borderRadius={BoxRadius.sm} />
      </HStack>
    </TableContent>
  );
};
